export const menuList = [
  {
    id: '1',
    name: '首页',
    ename: 'Home',
    path: '/m/index',
    type: 1,
    parentId: '',
    hasChildren: false,
    show: true
  },
  {
    id: '2',
    name: '产品家族',
    ename: 'Product Family',
    path: '',
    type: 1,
    parentId: '',
    hasChildren: true,
    show: true
  },
  {
    id: '2-1',
    name: '企业健康管理方案',
    ename: 'Corporate Health Management Solutions',
    path: '/m/thirdService/healthPlan',
    type: 2,
    parentId: '2',
    hasChildren: false,
    show: false
  },
  {
    id: '2-2',
    name: '个人健康管理方案',
    path: '/m/products',
    ename: 'Personal Health Management Solutions',
    type: 2,
    parentId: '2',
    hasChildren: true,
    show: false
  },
  {
    id: '2-2-1',
    name: '新燕宝',
    ename: 'Xinyanbao',
    path: '/m/productDetails/DBXYB2024',
    type: 3,
    parentId: '2-2',
    hasChildren: false,
    show: false,
    langShow: true
  },
  {
    id: '2-2-2',
    name: '喜燕宝',
    ename: 'Xiyanbao',
    path: '/m/productDetails/DBXYBHYB',
    type: 3,
    parentId: '2-2',
    hasChildren: false,
    show: false,
    langShow: true
  },
  {
    id: '2-2-3',
    name: '福燕宝',
    ename: 'Fuyanbao',
    path: '/m/productDetails/DB_BJ_033',
    type: 3,
    parentId: '2-2',
    hasChildren: false,
    show: false,
    langShow: true
  },
  {
    id: '2-2-4',
    name: '小燕宝',
    ename: 'Xiaoyanbao',
    path: '/m/productDetails/ZLXYB',
    type: 3,
    parentId: '2-2',
    hasChildren: false,
    show: false,
    langShow: true
  },
  {
    id: '2-2-5',
    name: '臻荣耀',
    ename: 'Zhenrongyao',
    path: '/m/productDetails/ZLZRY2023',
    type: 3,
    parentId: '2-2',
    hasChildren: false,
    show: false
  },
  {
    id: '2-2-6',
    name: '臻合意',
    ename: 'Zhenheyi',
    path: '/m/productDetails/DB_BJ_024',
    type: 3,
    parentId: '2-2',
    hasChildren: false,
    show: false,
    langShow: true
  },
  {
    id: '2-2-7',
    name: '臻高端',
    ename: 'Zhengaoduan',
    path: '/m/productDetails/DBZGD',
    type: 3,
    parentId: '2-2',
    hasChildren: false,
    show: false,
    langShow: true
  },
  {
    id: '2-2-8',
    name: '喜燕宝全球版',
    ename: 'Xiyanbao(Global)',
    path: '/m/productDetails/DB_BJ_014',
    type: 3,
    parentId: '2-2',
    hasChildren: false,
    show: false,
    langShow: true
  },
  {
    id: '2-2-9',
    name: '鸥思脉',
    ename: 'Ousimai',
    path: '/m/productDetails/DB_BJ_034',
    type: 3,
    parentId: '2-2',
    hasChildren: false,
    show: false,
    langShow: true
  },
  {
    id: '2-2-9',
    name: '中间带救援',
    ename: 'MediLink-Global Assist',
    path: 'http://www.medilink-globalassist.com/home',
    type: 3,
    parentId: '2-2',
    hasChildren: false,
    show: false,
    langShow: true
  },
  {
    id: '3',
    name: '第三方管理服务',
    ename: 'Third-party Management Services',
    path: '',
    type: 1,
    parentId: '',
    hasChildren: true,
    show: true
  },
  {
    id: '3-1',
    name: '第三方管理服务',
    path: '/m/thirdService',
    ename: 'Third-party Management Services',
    type: 2,
    parentId: '3',
    hasChildren: false,
    show: false
  },
  {
    id: '3-2',
    name: '特色服务',
    ename: 'Special Services',
    path: '/m/featureSevice',
    type: 2,
    parentId: '3',
    hasChildren: false,
    show: false
  },
  {
    id: '4',
    name: '网络医疗',
    ename: 'Medical Network',
    path: '/m/joinus',
    type: 1,
    parentId: '',
    hasChildren: false,
    show: true
  },
  {
    id: '5',
    name: '医疗服务',
    ename: 'Medical Services',
    path: '',
    type: 1,
    parentId: '',
    hasChildren: true,
    show: true
  },
  {
    id: '5-1',
    name: '企业保健服务',
    ename: 'Corporate Health Service',
    path: '/m/medicalService/company',
    type: 2,
    parentId: '5',
    hasChildren: false,
    show: false
  },
  {
    id: '5-3',
    name: '中间带·宜汇',
    ename: '',
    path: '/m/medicalService/clinic/yihui',
    type: 2,
    parentId: '5',
    hasChildren: false,
    show: false,
    langShow: true
  },
  {
    id: '5-4',
    name: '中间带·百诺',
    ename: '',
    path: '/m/medicalService/clinic/bainuo',
    type: 2,
    parentId: '5',
    hasChildren: false,
    show: false,
    langShow: true
  },
  {
    id: '5-5',
    name: '中间带·丽铂医疗美容',
    ename: '',
    path: '/m/medicalService/clinic/lippo',
    type: 2,
    parentId: '5',
    hasChildren: false,
    show: false,
    langShow: true
  },
  {
    id: '5-6',
    name: '中间带·深圳旗舰店',
    ename: '',
    path: '/m/medicalService/clinic/shenzhen',
    type: 2,
    parentId: '5',
    hasChildren: false,
    show: false,
    langShow: true
  },
  {
    id: '5-7',
    name: '中间带·成都旗舰店',
    ename: '',
    path: '/m/medicalService/clinic/chendu',
    type: 2,
    parentId: '5',
    hasChildren: false,
    show: false,
    langShow: true
  },
  {
    id: '6',
    name: '关于我们',
    ename: 'About Us',
    path: '/m/about',
    type: 1,
    parentId: '',
    hasChildren: false,
    show: true
  },
]